import type { ReactNode } from "react"

import { Close } from "@mui/icons-material"
import { Box, Divider, Drawer, IconButton, Typography } from "@mui/material"

type Props = {
  children: ReactNode
  onClose: () => void
  open: boolean
  subtitle?: ReactNode
  title: ReactNode
  width?: number
}

const DetailDrawer = ({ children, onClose, open, subtitle, title, width = 380 }: Props) => {
  return (
    <Drawer anchor="right" onClose={onClose} open={open} PaperProps={{ sx: { width: { sm: width, xs: "100%" } } }}>
      <Box display="flex" flexDirection="column" height="100%">
        <Box alignItems="center" display="flex" flexShrink={0} gap={2} justifyContent="space-between" px={3} py={2}>
          <Box minWidth={0}>
            <Typography fontWeight={700} variant="h6">
              {title}
            </Typography>
            {subtitle && (
              <Typography color="text.secondary" variant="caption">
                {subtitle}
              </Typography>
            )}
          </Box>
          <IconButton aria-label="Đóng" onClick={onClose}>
            <Close />
          </IconButton>
        </Box>

        <Divider />

        <Box flex={1} minHeight={0} overflow="auto" p={3}>
          {children}
        </Box>
      </Box>
    </Drawer>
  )
}

export default DetailDrawer
